import { crudService } from '../_services';
import { history } from '../_helpers';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';
import { stringUtils } from '../_utils';

export const cursosDaguaAction = {
    getCursoDagua,
    getCursoDaguaSelect,
    getCursoDaguaById,
    onChangeProps,
    editCursoDaguaInfo,
    createCursoDagua,
    deleteCursoDaguaById,
    clear
};

let filterModel = {
    Page: 1,
    Limit: 10,
    Term: ''
};

function getCursoDagua(filterModel) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'cursosDagua' + stringUtils.serialize(filterModel);
        crudService.get(apiEndpoint)
            .then((response) => {
                if (response.data) {
                    dispatch(changeCursoDaguasList(response.data.items, response.data.totalPages));
                }
                alerts.clean();
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function getCursoDaguaSelect() {
    return dispatch => {
        let apiEndpoint = 'cursosDagua/select';
        crudService.get(apiEndpoint)
            .then((response) => {
                if (response.data) {
                    response.data.unshift({ value: '', text: ' SELECIONE ...' });
                    dispatch(changeCursoDaguasList(response.data, null));
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function createCursoDagua(payload) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'cursosDagua/';
        crudService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    //history.push(ret.path);
                    alerts.success(ret.message, ret.path);
                } else {
                    alerts.warning(response.request.responseText);
                }
            });
    };
}
function getCursoDaguaById(id) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'cursosDagua/' + id;
        crudService.get(apiEndpoint)
            .then((response) => {
                dispatch(editCursoDaguasDetails(response.data));
                alerts.clean();
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function onChangeProps(props, event) {
    return dispatch => {
        if (event.target.type === 'checkbox') {
            dispatch(handleOnChangeProps(props, event.target.checked));
        } else {
            dispatch(handleOnChangeProps(props, event.target.value));
        }
    };
}
function editCursoDaguaInfo(id, payload) {
    return dispatch => {
        alerts.waiting();
        let apiEndpoint = 'cursosDagua/' + id;
        crudService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    //history.push(ret.path);
                    alerts.success(ret.message, ret.path);
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function deleteCursoDaguaById(id) {
    return dispatch => {

        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir o registro?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
        .then((willDelete) => {
            if (willDelete.value) {
                alerts.waiting();
                let apiEndpoint = 'cursosDagua/' + id;
                crudService.deleteDetail(apiEndpoint)
                    .then((response) => {
                        if (response.request.status === 200) {
                            var ret = JSON.parse(response.request.responseText);
                            dispatch(deleteCursoDaguasDetails());
                            dispatch(getCursoDagua(filterModel));
                            alerts.success(ret.message);
                        } else {
                            alerts.warning(response.request.responseText);
                        }
                    }).catch((err) => {
                        console.log(err);
                        alerts.error(err);
                    });

            }
        });

    };
}
export function changeCursoDaguasList(cursoDagua, totalPages) {
    return {
        type: "FETECHED_ALL_CURSO_DAGUA",
        cursoDagua: cursoDagua,
        totalPages: totalPages
    };
}
export function clear() {
    return {
        type: "CURSO_DAGUA_CLEAR"
    };
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE_CURSO_DAGUA",
        props: props,
        value: value
    };
}
export function editCursoDaguasDetails(cursoDagua) {
    return {
        type: "CURSO_DAGUA_DETAIL",
        id: cursoDagua.id,
        nome: cursoDagua.nome,
        excluido: cursoDagua.excluido,
    };
}
export function updatedUserInfo() {
    return {
        type: "CURSO_DAGUA_UPDATED"
    };
}
export function createUserInfo() {
    return {
        type: "CURSO_DAGUA_CREATED_SUCCESSFULLY"
    };
}
export function deleteCursoDaguasDetails() {
    return {
        type: "DELETED_CURSO_DAGUA_DETAILS"
    };
}